module.exports = __webpack_public_path__ + "img/menuboard_mc_cafe.af665928.png";